var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 23.1431C18.1543 23.1431 23.1431 18.1543 23.1431 12.0003C23.1431 5.84625 18.1543 0.857422 12.0003 0.857422C5.84625 0.857422 0.857422 5.84625 0.857422 12.0003C0.857422 18.1543 5.84625 23.1431 12.0003 23.1431Z",
    fill: "#6C757D",
    fillOpacity: 0.7,
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 12.8578C12.4741 12.8578 12.8578 12.4741 12.8578 12.0007C12.8578 11.5273 12.4741 11.1436 12.0007 11.1436C11.5273 11.1436 11.1436 11.5273 11.1436 12.0007C11.1436 12.4741 11.5273 12.8578 12.0007 12.8578Z",
    fill: "#6C757D",
    fillOpacity: 0.7,
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85714 12.8578C7.33053 12.8578 7.71429 12.4741 7.71429 12.0007C7.71429 11.5273 7.33053 11.1436 6.85714 11.1436C6.38376 11.1436 6 11.5273 6 12.0007C6 12.4741 6.38376 12.8578 6.85714 12.8578Z",
    fill: "#6C757D",
    fillOpacity: 0.7,
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1433 12.8578C17.6167 12.8578 18.0004 12.4741 18.0004 12.0007C18.0004 11.5273 17.6167 11.1436 17.1433 11.1436C16.6699 11.1436 16.2861 11.5273 16.2861 12.0007C16.2861 12.4741 16.6699 12.8578 17.1433 12.8578Z",
    fill: "#6C757D",
    fillOpacity: 0.7,
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.5cc4e858398eae8d378c339381954533.svg";
export { ForwardRef as ReactComponent };